import { z } from "zod";
// The catalog picker of the mobile itinerary (CHT-754): `GET /customer/trips/:tripId/catalog-items`. A customer who adds an item
// to a trip plan picks a PUBLISHED catalog item. This answer is a closed list of keys. It has no price, no description body, no
// media path, no staff field, no draft and no supplier data. The item is added by `catalogItemId` through the edit route
// (`ADD_ITEM`), so the picker needs only enough to recognise the place.
/** The most items of one page. */
export const CUSTOMER_CATALOG_PICKER_MAX_LIMIT = 20;
/** The longest search text. The search use case reads at most 16 word tokens. */
export const CUSTOMER_CATALOG_PICKER_MAX_QUERY = 80;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/u;
const code = z.string().min(1).max(64);
export const customerCatalogPickerTagSchema = z.strictObject({
    namespace: code,
    code,
    label: z.string().min(1).max(100),
});
export const customerCatalogPickerItemSchema = z.strictObject({
    id: z.string().regex(UUID),
    itemType: code,
    name: z.string().min(1).max(200),
    locality: z.string().max(100).nullable(),
    countryCode: z
        .string()
        .regex(/^[A-Z]{2}$/u)
        .nullable(),
    shortDescription: z.string().max(500).nullable(),
    /** Dietary and feature tags, at most 6, in a fixed order. */
    tags: z.array(customerCatalogPickerTagSchema).max(6),
});
export const customerCatalogPickerPageSchema = z.strictObject({
    items: z.array(customerCatalogPickerItemSchema).max(CUSTOMER_CATALOG_PICKER_MAX_LIMIT),
    /** The id to continue after. `null` at the end, and always `null` for a text search (a ranked shortlist has no next page). */
    nextCursor: z.string().regex(UUID).nullable(),
    /** What the list is limited to: the place of the trip. `null` when the trip names no country. */
    place: z
        .strictObject({
        locality: z.string().max(100).nullable(),
        countryCode: z.string().regex(/^[A-Z]{2}$/u),
    })
        .nullable(),
});
